import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { CommonLabelAndValueList } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';

const CompanyInformationSectionImpl: React.FC = () => {
  const {
    reviewAndSubmitNominationPageUiStore,
  } = useStores();

  return (
    <FlexBox
      wrap
      isFullWidth
      as='section'
      className='nomination-section'
    >
      <Text
        as='h3'
        block
        weight='semibold'
        size={400}
      >
        Company information
      </Text>
      <FlexBox
        isFullWidth
        direction='column'
        className='nomination-section__list'
      >
        <FlexBox 
          isFullWidth
          aligns='start'
        >
          <CommonLabelAndValueList 
            label='Partner ID:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.mpnId} 
          />
          <CommonLabelAndValueList 
            label='Company:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.companyName} 
          />
        </FlexBox>
        <FlexBox 
          isFullWidth
          aligns='start'
        >
          <CommonLabelAndValueList 
            label='Address 1:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.address1} 
          />
          <CommonLabelAndValueList 
            label='Address 2:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.address2} 
          />
        </FlexBox>
        <FlexBox 
          isFullWidth
          aligns='start'
        >
          <CommonLabelAndValueList 
            label='City:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.city} 
          />
          <CommonLabelAndValueList 
            label='State:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.stateProvince} 
          />
        </FlexBox>
        <FlexBox 
          isFullWidth
          aligns='start'
        >
          <CommonLabelAndValueList 
            label='Postal code:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.postalCode} 
          />
          <CommonLabelAndValueList 
            label='Country:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.country?.displayName} 
          />
        </FlexBox>
        <FlexBox 
          isFullWidth
          aligns='start'
        >
          <CommonLabelAndValueList 
            label='Company phone number:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.phoneNumber} 
          />
          <CommonLabelAndValueList 
            label='Website URL:' 
            childrenFallback={reviewAndSubmitNominationPageUiStore.currentNominationOrganization?.websiteUrl} 
          />
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
}

export const CompanyInformationSection = observer(CompanyInformationSectionImpl);
